import { onMounted, onUnmounted, ref } from "vue";

const TEXT_BOXES =
  'input:not([type]), input[type="text"], input[type="search"], input[type="url"], input[type="email"], textarea, [contenteditable="true"]';

// Whether a text box has focus, which on a phone means the keyboard is up, and which box
export function useTyping() {
  const typing = ref(false);
  const focused = ref(null);
  const update = () => {
    const element = document.activeElement;
    const isTextBox = Boolean(element?.matches?.(TEXT_BOXES));
    typing.value = isTextBox;
    focused.value = isTextBox ? element : null;
  };
  // Focus moving between two boxes blurs one before the next is focused
  const onFocusOut = () => setTimeout(update, 0);
  onMounted(() => {
    document.addEventListener("focusin", update);
    document.addEventListener("focusout", onFocusOut);
    update();
  });
  onUnmounted(() => {
    document.removeEventListener("focusin", update);
    document.removeEventListener("focusout", onFocusOut);
  });
  return { typing, focused };
}
